import wordFilter from 'bad-words';

const BASE_SAFE_FILTER = new wordFilter();

//Custom Blacklist for language/words as determined by Sony
const sonyWordBlacklist = [
	'sonysucks',
	'sonysuck',
	's0ny',
];

//Create filter that includes additional blacklisted language
let SONY_SAFE_FILTER = new wordFilter();
SONY_SAFE_FILTER.addWords(...sonyWordBlacklist);
SONY_SAFE_FILTER.removeWords('preteen', 'sex', 'sexy', 'dominatrics', 'dominatrix', 'masochist', 'masokist', 'sadist', 'orgasm', 'penis', 'vagina', 'vulva', 'scrotum', 'breasts', 'qweir', 'lezzian', 'lesbian', 'gay', 'bi', 'bisexual', 'queer', 'trans', 'intersex', 'intersexual');
const nameValidationRegex = /[^a-z0-9_\-. ]/gi;

function escapeRegExp(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

const isTextCensored = string => {
	//Using our base list of blacklisted words performs a simple regex to see if it includes those words in any manner
	return (
		BASE_SAFE_FILTER.list.filter(word => {
			return new RegExp(escapeRegExp(word), 'gi').test(string);
		}).length > 0 || false
	);
};

// Randomize array element and return new shuffled array
// Using Durstenfeld shuffle algorithm.
// Reference: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array

const SHUFFLE_ARRAY = array => {
    const a = array.slice();

    for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
    }

    return a;
};

const isNameValid = name => {
	return !nameValidationRegex.test(name);
};

export {
	isTextCensored,
	BASE_SAFE_FILTER,
	SONY_SAFE_FILTER,
	SHUFFLE_ARRAY,
	isNameValid
};
